import Landing from "./pages/Landing";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import StaffManagement from "./pages/StaffManagement";
import ItemManagement from "./pages/ItemManagement";
import Reports from "./pages/Reports";
import AdminDashboard from "./pages/AdminDashboard";
import AddUser from "./pages/AddUser";
import EditUser from "./pages/EditUser";
import AddItem from "./pages/AddItem";
import EditItem from "./pages/EditItem";
import ProtectedRoute from "./pages/ProtectedRoute";

export default function App() {
    return (
        <div className=" font['Body'] flex  h-[100vh] bg-[#1EA6D0] text-white">
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Landing />} />
                    <Route
                        path='/dashboard'
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path='/admin' element={<AdminPanel />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path='staff' element={<StaffManagement />}>
                            <Route index element={<AddUser />} />
                            <Route path='edit' element={<EditUser />} />
                        </Route>
                        <Route path='items' element={<ItemManagement />}>
                            <Route index element={<AddItem />} />
                            <Route path='edit' element={<EditItem />} />
                        </Route>
                        <Route path='reports' element={<Reports />} />
                    </Route>
                    <Route path='*' element={<div>Error</div>} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}
